<template>
  <div>
    <QS-h4-title title="应收款项" />
    <el-form ref="collectionRecordAddTable" :model="tableDataFrom" :rules="rules">
      <QS-common-table
        row-key="id"
        :columns="columns"
        :data="tableDataFrom.tableData"
        :pagination="false"
      >
      </QS-common-table>
    </el-form>
      <!-- 底部数据统计 -->
  <div class="amountTotal">
    <div>
      <span class="amountItem">
        剩余应收金额：
        <span class="amount" v-thousand-separator="remainAmountTotal"></span>
        元
      </span>
      <span class="amountItem">
        本次收取金额：
        <span class="amount" v-thousand-separator="amountTotal"></span>
        元
      </span>
    </div>
    <div>
      <span>
        仍需收取金额：
        <span class="amount" v-thousand-separator="continueAmountTotal"></span>
        元
      </span>
    </div>
  </div>
  </div>
  </template>

<script>
import { limitMoreZero } from '@/utils/validate'
import { getCollectionRecordList, getAccountDetail } from '@/api/domain/returnLease'
import { mapState } from 'vuex'
import config from './config.js'
import { overdueUtils } from '@/pages/utils/overdue'
import { operateMaxShowLength } from '@/store/dict/config'

export default {
  name: 'CollectionRecordAddTable',
  data() {
    const validateAmount = (rule, value, callback) => {
      const index = rule.field.split('.')[1]
      const { remainAmount } = this.tableDataFrom.tableData[index]
      if (Number(value) <= Number(remainAmount) && Number(value) > 0 && remainAmount !== '') {
        callback()
      } else {
        if (Number(value) > Number(remainAmount)) {
          this.tableDataFrom.tableData[index].amount = Number(remainAmount)
        }
        callback(new Error('请输入大于0至剩余应收范围内的金额'))
      }
    }
    const { getOverdueItemByRentItem } = overdueUtils.call(this)
    return {
      columns: config.call(this).columns,
      renderColumns: [
        {
          name: 'amount',
          columnProps: {
            label: '本次收款金额（元）',
            prop: 'amount',
            width: 230,
          },
          render: (scope) => {
            // 对租金行，通过应收ID匹配关联单id，确认是否有滞纳金
            const overdueItem = getOverdueItemByRentItem(scope.row.id)
            return (
              <el-form-item
                prop={`tableData.${scope.$index}.amount`}
                rules={this.rules.amount}
              >
                <el-input
                  disabled={!!overdueItem}
                  placeholder="请输入"
                  v-model={scope.row.amount}
                  onInput={(val) => this.amountChange(val, scope.$index)}
                ></el-input>
              </el-form-item>
            )
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            fixed: 'right',
            width: 240,
          },
          maxShowLength: operateMaxShowLength,
          render: (scope) => {
            let popoverContent = '确定删除该应收款项吗?'
            // 如果是租金
            if (scope.row.content === 1) {
              const overdueItem = getOverdueItemByRentItem(scope.row.id)
              if (overdueItem) {
                popoverContent = '确定删除该应收款项么，对应滞纳金会同时删除'
              }
            }
            return (this.isShowDeleteBtn && (
              <el-popover
                ref={scope.$index}
                placement="bottom"
                width="230"
                popper-class="delete-order"
              >
                <p>{popoverContent}</p>
                <div
                  class="delete-order-btns"
                  style={{ textAlign: 'right', margin: 0 }}
                >
                  <el-button
                    size="mini"
                    class="cancel-btn"
                    onClick={() => this.cancel()}
                  >
                    取消
                  </el-button>
                  <el-button
                    type="primary"
                    size="mini"
                    onClick={() => this.handleDel(scope.row.serialNum)}
                  >
                    确定
                  </el-button>
                </div>
                <el-button type="text" slot="reference">
                  删除
                </el-button>
              </el-popover>
            )) ||
            '--'
          },
        },
      ],
      rules: {
        categoryCode: [
          { required: true, message: '收款类目不能为空', trigger: 'change' },
        ],
        amount: [
          {
            required: true,
            message: '本次收款金额不能为空',
            trigger: ['blur', 'change'],
          },
          { validator: validateAmount },
        ],
      },
      tableDataFrom: {
        tableData: [],
      },
      customerObj: {}, // 用户对象
    }
  },
  computed: {
    ...mapState({
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
    }),
    isShowDeleteBtn() {
      return this.tableDataFrom.tableData.length > 1
    },
    // 剩余应收金额
    remainAmountTotal() {
      let remainAmountTotal = 0
      const { tableData } = this.tableDataFrom
      tableData.length > 0 &&
        tableData.forEach((item) => {
          remainAmountTotal += Number(item.remainAmount)
        })
      return remainAmountTotal
    },
    // 本次应收金额
    amountTotal() {
      let amountTotal = 0
      const { tableData } = this.tableDataFrom
      tableData.length > 0 &&
        tableData.forEach((item) => {
          amountTotal += ((Number(item.amount)) * 100)
        })
      return (amountTotal / 100).toFixed(2)
    },
    // 仍需收取金额
    continueAmountTotal() {
      return this.remainAmountTotal - this.amountTotal
    },
  },
  watch: {
    'tableDataFrom.tableData': {
      handler(val) {
        if (val.length === 1) {
          // 当列表列数为14时
          if (this.columns?.length === 14) this.columns.pop()
        }
        this.$emit('setTableData', val)
      },
      immediate: true,
      deep: true,
    },
  },
  props: {
    ids: {
      type: String,
      default: '',
    },
  },
  created() {
    this.columns = [...this.columns, ...this.renderColumns]
    this.getList()
  },
  methods: {
    // 获取应收款项列表
    getList() {
      getCollectionRecordList({ ids: this.ids.split(',') })
        .then((res) => {
          const { code, data = [] } = res
          if (code !== 1) return
          this.tableDataFrom.tableData =
              (data.length > 0 &&
                data.map((item, index) => {
                  return {
                    ...item,
                    amount: item.remainAmount || '',
                    categoryCode: item.categoryCode || '',
                    serialNum: index + 1,
                  }
                })) ||
              []
          const { customerId } = data[0] || {}
          this.setCustomObj(data[0] || {}, ['customer', 'customerId', 'customerType'])
          // 根据用户Id获取账号信息
          customerId && this.getPayerChange(customerId)
        })
        .catch((error) => {
          console.log(error, 'getCollectionRecordList')
        })
    },
    // 设置用户信息
    setCustomObj(obj, keys) {
      // accountNo：开户账号，accountName：账户名称，bankName：开户银行名称
      if (typeof obj !== 'object') return
      keys.forEach((key) => {
        if (key === 'customer') {
          this.customerObj.customerName = obj.customer
        }
        this.customerObj[key] = obj[key] || ''
      })
      this.$emit('setCustomer', this.customerObj)
    },
    // 付款方选中事件
    async getPayerChange(customerId) {
      if (customerId) {
        try {
          const { code, data } = await getAccountDetail({
            customerId,
            customerType: 2,
          })
          if (code !== 1) return
          this.setCustomObj(data, ['paymentAccount', 'accountNo', 'bankName'])
        } catch (error) {
          console.log(error, 'getPayerChange')
        }
      }
    },
    // 校验
    // eslint-disable-next-line vue/no-unused-properties
    handleValidate() {
      const {
        $refs,
        tableDataFrom: { tableData },
      } = this
      return new Promise((resolve) => {
        $refs.collectionRecordAddTable.validate((valid) => {
          if (!valid) {
            const notSubmit = tableData.some((item) => item.amount === '')
            if (notSubmit) this.$message.error('请填写收款金额')
            return false
          }
          resolve()
        })
      })
    },

    // popper弹框取消
    cancel() {
      document.body.click()
    },

    // 监听金额变化
    amountChange(value, index) {
      limitMoreZero(value, (val) => {
        this.$emit('amountChange', val, index)
      })
    },
    // 获取数据中type类型所在位置
    getIndex(key) {
      const _index = this.tableDataFrom.tableData.findIndex((item) => item.serialNum === key)
      return _index
    },

    // 删除条目
    handleDel(type) {
      this.tableDataFrom.tableData.splice(this.getIndex(type), 1)
      this.cancel()
    },
  },
}
</script>

  <style lang="scss" scoped>
  .add-table ::v-deep .el-form-item {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .add-table ::v-deep td {
    padding: 0 !important;
  }
  .add-table {
    ::v-deep thead tr {
      background-color: #f7f8fa;
    }
  }
  #app .add-table ::v-deep thead tr th {
    border: none !important;
  }
  .delete-order {
    &-btns {
      text-align: right;
      margin: 0;
      display: flex;
      justify-content: flex-end;
      margin-top: 20px !important;
      .cancel-btn {
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 2px;
        border: 1px solid #dcdee0;
        font-family: PingFangSC-Regular;
        color: #323233;
        border-radius: 3px;
        font-size: 12px;
      }
    }
  }
  .amountTotal {
  display: flex;
  align-items: flex-end;
  flex-direction: column;

  .amountItem {
    margin-left: 10px;
  }

  .amount {
    font-weight: 500;
    font-size: 16px;
    color: #3d3d3d;
  }
}
  </style>
